<template>
    <div class="media-gallery-container">
        <template v-if="buttons">
            <media-buttons
                container-class="media-gallery-buttons"
                :options="buttons_options" 
                :active="active"
                :icons="true"
                @selected="mediaSelected"
            />
        </template>
        
        <div class="media-gallery-content">
            <images-gallery
                ref="images_gallery"
                v-if="isActive('images')"
                :images="media.images"
                :active-index="activeImage"
                :thumb="true"
            />

            <media-virtual-tour
                v-if="isActive('virtual_tour')"
                :src="media.virtual_tour"
            />

            <media-video
                v-if="isActive('video')"
                :src="media.video"
            />

            <detail-map 
                v-if="isActive('map')"
                :latitude="media.map.latitude" 
                :longitude="media.map.longitude"
                :exact="media.map.exact"
                :poi="poi"
            />

            <images-gallery
                ref="floor_plans_gallery"
                v-if="isActive('floor_plans')"
                :images="media.floor_plans"
                :has-icons="true"
                :thumb="true"
            />
        </div>
    </div>
</template>

<script>
import DetailMap from '../DetailMap'
import MediaButtons from './MediaButtons'
import ImagesGallery from './ImagesGallery'
import MediaVideo from './MediaVideo'
import MediaVirtualTour from './MediaVirtualTour'

export default {
    components: {
        'detail-map': DetailMap,
        'media-buttons': MediaButtons,
        'images-gallery': ImagesGallery,
        'media-video': MediaVideo,
        'media-virtual-tour': MediaVirtualTour,
    },

    props: {
        buttons: {
            type: Boolean,
            default: true
        },

        firstActive: {
            type: String,
            default: 'images'
        },

        media: {
            type: Object,
            required: true,
        },

        activeImage: {
            type: Number,
            default: 0,
        },

        poi: {
            type: Object,
            default() {
                return {
                    country: this.$root.country_full_name,
                    endpoint: window.tecnomapsEndpoint + '/v2/services/poi',
                    listener: false,
                    all: ['public_transport', 'school', 'pharmacy', 'parking', 'ev_charging', 'shop', 'bank', 'fuel', 'market', 'hospital', 'monument', 'post', 'bar', 'restaurant', 'park'],
                    selected: ['public_transport', 'school', 'pharmacy', 'ev_charging'],
                    element: 'detail-map-poi-controller'
                }
            }
        }
    },

    data() {
        return {
            active: this.firstActive,
            buttons_options: {},
        }
    },

    computed: {
        lang() {
            return this.$root.lang.estate_detail
        },
    },

    mounted() {
        this.buttons_options = {
            has_smartvt360: this.media.has_smartvt360,
            has_realistico: this.media.has_realistico,
            video: !this.empty(this.media.video),
            virtual_tour: !this.empty(this.media.virtual_tour),
            images: !this.empty(this.media.images),
            floor_plans: !this.empty(this.media.floor_plans),
            map: !this.empty(this.media.map),
        }
    },

    methods: {
        mediaSelected(event) {
            this.active = null
            setTimeout(() => {
                this.active = event
            }, 100)
        },

        isActive(key) {
            return this.media[key] && this.active == key
        },

        empty(value) {
            return value === null || value === undefined || value === [] || value === {} || value === 0 || value === false
        }
    }
}
</script>
